import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'service-evolution-quality-banner',
	templateUrl: './service-evolution-quality-banner.component.html',
	styleUrls: ['./service-evolution-quality-banner.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ServiceEvolutionQualityBanner {
	@Input()
	quality!: ServiceEvolutionQuality;

	@Input()
	mode!: 'modal' | 'input';

	protected icons: Map<ServiceEvolutionQuality, string> = new Map([
		['approved', 'freud-icon-circle-check'],
		['declined', 'freud-icon-exclamation-circle'],
		['default', 'freud-icon-exclamation-circle'],
	]);

	constructor(public translateService: TranslateService) {}

	getBannerMessage(): string {
		return `PROMPTUARY.SERVICE_EVOLUTION_QUALITY_BANNER.${this.mode.toUpperCase()}.${this.quality.toUpperCase()}`;
	}

	shouldRenderBanner(): boolean {
		return this.qualityIsAllowedForMode();
	}

	qualityIsAllowedForMode(): boolean {
		return (
			(this.mode === 'input' && this.qualityIsAllowedForInput()) ||
			(this.mode === 'modal' && this.qualityIsAllowedForModal())
		);
	}

	qualityIsAllowedForInput(): boolean {
		return ['default', 'approved', 'declined'].includes(this.quality);
	}

	qualityIsAllowedForModal(): boolean {
		return ['approved', 'declined'].includes(this.quality);
	}

	isLoadingInput(): boolean {
		return this.quality === 'loading' && this.mode === 'input';
	}
}

export type ServiceEvolutionQuality =
	| 'default'
	| 'loading'
	| 'approved'
	| 'declined';
